
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcTable as ObcTableElement} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
 import {ObcTableRowClickEvent, ObcTableCellClickEvent, ObcTableCellCheckboxChangeEvent, ObcTableCellTagClickEvent, ObcTableSelectionChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
 export type {ObcTableRowClickEvent, ObcTableCellClickEvent, ObcTableCellCheckboxChangeEvent, ObcTableCellTagClickEvent, ObcTableSelectionChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
 

 
 export const ObcTable = createComponent({
   react: React,
   tagName: 'obc-table',
   elementClass: ObcTableElement,
   events: {
     
     onRowClick: 'row-click' as EventName<ObcTableRowClickEvent>,
     onCellButtonClick: 'cell-button-click' as EventName<ObcTableCellClickEvent>,
     onCellCheckboxChange: 'cell-checkbox-change' as EventName<ObcTableCellCheckboxChangeEvent>,
     onCellTagClick: 'cell-tag-click' as EventName<ObcTableCellTagClickEvent>,
     onSelectionChange: 'selection-change' as EventName<ObcTableSelectionChangeEvent>,
   }
  });
 
 